<template>
  <div>
    <el-card>
      <div style="font-size: 16px; margin-bottom: 20px">
        {{ goodsItemIdData.name }}
      </div>
      <el-row :span="24">
        <el-col :span="24">
          <div>
            <el-button type="primary" @click="addGoodsVideo" icon="el-icon-plus">系列课</el-button>
          </div>
        </el-col>
      </el-row>
      <el-table ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; " v-loading="Loading" border @selection-change="selectionChange" rowshift="table-list">
        <el-table-column show-overflow-tooltip prop="shift" label="班次"></el-table-column>
        <el-table-column show-overflow-tooltip prop="courseTitle" label="课程名"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="绑定商品">
          <template slot-scope="scope">
            <span style="cursor:pointer;color:blue;" v-if="scope.row.name" @click="clickedIdx=scope.$index,openaddFormVisible()">{{scope.row.name}}</span>
            <span style="cursor:pointer;color:blue;" v-else @click="clickedIdx=scope.$index,openaddFormVisible()">绑定</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="220px">
          <template slot-scope="scope">
            <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red" @confirm="deleteGoodsItem(scope)" @onCancel="deleteCancel" title="确定解绑吗？">
              <el-button type="text" slot="reference">解绑</el-button>
            </el-popconfirm>
            <span style="margin-left: 30px" class="mainColor" @click="seeDetail(scope)">查看</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="添加排班" :visible.sync="batchModal" width="800px" left>
      <div class="base-info-box">
        <div v-for="(item, index) in memberList" :key="index" class="row jsa mb10">
          <div class="form-row">
            <div class="label">班次名称：</div>
            <div class="form-item alc">
              <el-input type="text" maxlength="15" placeholder="请输入" v-model="item.shift"></el-input>

              <!-- <a-icon type="plus-circle" style="margin-left:0.15rem;" @click="addMember" v-if="index==memberList.length-1" />
              <a-icon type="minus-circle" style="margin-left:0.15rem;" @click="deleteMember(num)" v-else /> -->
            </div>
          </div>
          <div class="form-row">
            <div class="label">课程名称：</div>
            <div class="form-item">
              <el-input type="text" maxlength="15" placeholder="请输入" v-model="item.courseTitle"></el-input>
              <i class="icons el-icon-circle-plus-outline" v-if="index==memberList.length-1" @click="addMember"></i>
              <i class="icons el-icon-remove-outline" @click="deleteMember(num)" v-else></i>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="batchModal = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加商品" :visible.sync="addFormVisible" width="855" left :close-on-click-modal="false">
      <el-form :label-width="formLabelWidth">
        <el-row :span="24">
          <el-col :sm="8" :md="8" :lg="6">
            <el-cascader :show-all-levels="false" ref="tree" placeholder="请选择所属科目" collapse-tags @change="subjectChange" :options="subjectTreeList" :props="subjectTreeProps" clearable></el-cascader>
          </el-col>
          <el-col :sm="8" :md="8" :lg="6">
            <el-select v-model="searchForm.type" clearable placeholder="请选择商品类型">
              <el-option v-for="item in goodsTypeList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :sm="8" :md="8" :lg="6">
            <el-input v-model="searchForm.name" placeholder="请输入商品名称"></el-input>
          </el-col>
          <el-col :sm="5" :md="5" :lg="6" align="right">
            <el-button type="primary" @click="pageList2">查询</el-button>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-table ref="singleTb" v-loading="loading" height="400" :data="addFormVisibleList" tooltip-effect="dark" style="width: 100%;margin-top:20px" @selection-change="handleSelectionChange" @select-all="onSelectAll" border>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="name" width="370" show-overflow-tooltip label="商品">
                <template slot-scope="row">
                  <el-row>
                    <el-col :span="8">
                      <span>
                        <img style="margin-right:10px;" height="60px" :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'" />
                      </span>
                    </el-col>
                    <el-col :span="16">
                      <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                      <span style="display:block;margin-left:10px;">
                        <span style="color:red">￥{{row.row.price}}</span>
                        <span style="text-decoration:line-through;color:rgb(162,170,188)">￥{{row.row.originalPrice}}</span>
                      </span>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="140" prop="agentPrice" label="售价">
                <template slot-scope="row">
                  <span style="display:block;">
                    <span style="color:red">￥{{row.row.agentPrice}}</span>
                    <span style="text-decoration:line-through;color:rgb(162,170,188)">￥{{row.row.price}}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column show-overflow-tooltip width="100"  prop="agentPrice" label="代理价">
                <template slot-scope="row">
                  <span style="color:red;font-weight:bold">￥{{row.row.agentPrice}}</span>
                </template>
              </el-table-column> -->
              <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
                <template slot-scope="row">{{row.row.validDay?row.row.validDay+'天':'不限'}}</template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="250" prop="subjectcourseTitle" label="所属科目"></el-table-column>
              <!-- <el-table-column show-overflow-tooltip width="60" prop="goodsCount" label="内容"></el-table-column> -->
            </el-table>
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]" style="margin-top: 20px;text-align: right;" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange2" @current-change="currentChange2"></el-pagination>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindGoodsByBatch">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import conmon from "../videoCourse/conmon";
import { mapGetters } from "vuex";
export default {
  components: { conmon },
  data () {
    return {
      memberList: [{
        shift: '',
        courseTitle: '',
      }],
      addFormVisibleList: [],
      addFormVisible: false,
      searchForm: {
        sell: 1,
        name: "",
        subjectIds: []
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        multiple: true,
        children: "children"
      },
      batchModal: false, Loading: false,
      queryData: {},
      powerList: [],
      checkList: [],
      isPrpover: false,
      videoDialog: false,
      bindVisible: false,
      comMonid: "",
      typeName: "",
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children"
      },
      goodsTypeList: [],
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children"
        // checkStrictly: true
      },
      loadingV: false,
      campusList: [],
      ClassInfoTree: [],

      videoCourseIds: [],
      subjectTreeList: [], //科目
      page1: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      videocoursePage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      actualOperationForm: {},
      addVideoVisible: false,
      addLiveVisible: false,
      addSubjectVisible: false,
      addChapterVisible: false,
      addActualOperationVisible: false,
      searchForm: {},
      videoSearchForm: {},
      liveSearchForm: {},
      subjectForm: {},
      chapterForm: {
        ppid: "",
        pid: "",
      },
      formLabelWidth: "80px",
      formLabelWidths: "100px",
      selection: "",
      multipleSelection: "",
      ids: [],
      fileAction: `${process.env.BASE_URL}/goodsItem/upload`,
      fileList: [],
      loading: true,
      goodsItemIdData: [],
      type: "",
      chapterListType: "",
      clickedIdx: 0,
    };
  },
  components: {
    draggable,
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    }
  },
  methods: {
    seeDetail (scope) {
      console.log(scope)
      this.$router.push({
        path: "/goodsItems",
        query: {
          updatePageGoodsItem: this.$route.query.updatePageGoodsItem,
          subjectId: this.$route.query.subjectId,
          goodsId: this.$route.query.goodsId,
          addWay: this.$route.query.addWay
        }
      })
    },
    bindGoodsByBatch () {
      if (this.ids.length && this.ids.length > 0) {
        this.api.goodsInfo.addGoodsSeriesRelation({
          "goodsSeriesId": this.$route.query.updatePageGoodsItem,//系列课商品id
          "goodsComboId": this.ids[0].objectId,//绑定的商品id
          "shift": this.page.rows[this.clickedIdx].shift,//班次
          'name': this.ids[0].name,
          "courseTitle": this.page.rows[this.clickedIdx].courseTitle //课程名
        }).then(res => {
          if (res.code == '200') {
            this.addFormVisible = false
            this.page.rows[this.clickedIdx].name = this.ids[0].name
            this.page.rows[this.clickedIdx].id = res.data.id
            this.page.rows = [...this.page.rows]
            console.log(this.page.rows)
          }
        })
      } else {
        this.$message.warning('请选择')
      }

    },
    deleteMember (num) {
      this.memberList.splice(num, 1)
    },
    openaddFormVisible () {
      this.addFormVisible = true;
      this.pageList2();
      this.api.getSubjectTreeList().then(result => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              delete items.children;
              // if (items.children.length != 0) {
              //   for (let itemss of items.children) {
              //     delete itemss.children;
              //   }
              // } else {
              //   // delete items.children;
              // }
            }
          } else {
            // delete item.children;
          }
        }
        this.subjectTreeList = result.data;
      }).catch(error => {
        console.log(error);
      });
    },
    addMember () {
      this.memberList.push({
        shift: '',
        courseTitle: '',
      })
    },
    sizeChange2 (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList2();
    },
    currentChange2 (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList2();
    },
    getGoodsItemData () {
      this.api.goodsInfo.getGoodsInfo({ id: this.$route.query.updatePageGoodsItem }).then((result) => {
        this.goodsItemIdData = result.data;
        console.log("this..goodsItemdata", this.goodsItemIdData);
        this.pageList();
      });
      console.log(this.goodsItemIdData);
    },
    pageList2 () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.searchForm.purchaserType = this.purchaserType;
      this.api.goodsInfo.pageList(this.searchForm).then(result => {
        this.loading = false;
        this.addFormVisibleList = result.data.records;
        this.page.total = result.data.total;
        this.arrsSelect = [];
        this.addFormVisibleList.forEach((item, index) => {
          let sty = true;
          this.subjectList.forEach(items => {
            if (item.id == items.id) {
              sty = false;
              this.$nextTick(() => this.$refs.multipleTables.toggleRowSelection(this.addFormVisibleList[index]))
            }
          });
          if (!sty) {
            this.arrsSelect.push(item);
          }
        });
      }).catch(error => {
        console.log(error);
      });
    },

    subjectChange (val) {
      if (val) {
        this.searchForm.subjectIds = [];
        val.forEach(item => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    // 范围弹出窗赋初值
    rangeCli (form) {
      this.checkList = [];
      this.powerList = JSON.parse(JSON.stringify(form.powerList));
      form.powerList.forEach((item) => {
        if (item.hasPower) this.checkList.push(item.power);
      });
    },
    // 范围更改提交
    sunmitType (element) {
      let val = 0;
      this.checkList.forEach((item) => (val = val | +item));
      let obj = JSON.parse(JSON.stringify(element));
      obj.power = val;
      // console.log(obj);
      this.api.videoInfo.updateGoodsItem(obj).then((res) => {
        if (res.code == 200) {
          element.isPrpover = false;
          this.$message.success(res.message);
        } else this.$message.error(res.message);
        this.pageList();
      });
    },
    opConmon (row, sty) {
      this.bindVisible = true;
      this.comMonid = sty == 1 ? row.objectId : row.id;
      this.typeName = row.type;
      this.pageList1();
    },
    pageList1 () {
      this.page1.videoCourseId = this.comMonid;
      this.api.videoInfo
        .pageList(this.page1)
        .then((result) => {
          if (result.success) {
            this.page1.rows = result.data.records;
            this.page1.total = result.data.total;
          } else {
            this.$message.error(result.message);
          }
        })

        .catch((error) => {
          console.log(error);
        });
    },
    closeDialog () {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    deleteCancel () {
      // alert(0);
    },
    datadragEnd (evt) {
      console.log(evt);
      let arr = [];
      this.page.rows.forEach((item, index) => {
        arr.push({
          id: item.id,
          sort: index + 1,
        });
      });
      console.log(arr);
      this.api.changeSort(arr).then((result) => {
        this.$message.success(result.message);
      })
        .catch((error) => {
          console.log(error);
        });
      evt.preventDefault();
      // console.log("拖动前的索引 :" + evt.oldIndex);
      // console.log("拖动后的索引 :" + evt.newIndex);
      // console.log(this.colors);
    },
    addGoodsVideo () {
      this.videocoursePageList();
      this.memberList = [{
        shift: '',
        courseTitle: '',
      }]
      this.batchModal = true;
    },

    videoSubjectChange (val) {
      this.videoSearchForm.courseIds = [];
      val.forEach((item) => {
        this.videoSearchForm.courseIds.push(item[2]);
      });
    },
    subjectChange (val) {
      this.subjectForm.ids = [];
      val.forEach((item) => {
        this.subjectForm.ids.push(item[2]);
      });
    },
    videocoursePageList () {
      this.videoSearchForm.pageSize = this.videocoursePage.pageSize;
      this.loadingV = true
      this.videoSearchForm.pageNumber = this.videocoursePage.pageNumber;
      this.api.classInfoPhase.pageList(this.videoSearchForm).then((result) => {
        this.loadingV = false
        this.videocoursePage.rows = result.data.records;
        this.videocoursePage.total = result.data.total;
      }).catch((error) => {
        this.loadingV = false
        console.log(error);
      });
    },
    addGoodsItemBatch () {
      if (this.page.rows && this.page.rows.length) {
        this.page.rows = this.page.rows.concat(this.memberList)
      } else {
        this.page.rows = []
        this.page.rows = this.page.rows.concat(this.memberList)
      }
      console.log(this.page)
      this.batchModal = false
    },
    deleteGoodsItem (row) {
      console.log(row)
      let params = {
        id: row.row.id
      }
      this.api.goodsInfo.delGoodsSeriesRelation(params).then((result) => {
        this.$message.success("解绑成功");
        this.page.rows.splice(row.$index, 1)
      });
    },

    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    sizeChange1 (pageSize) {
      this.page1.pageSize = pageSize;
      this.pageList1();
    },
    currentChange1 (pageNumber) {
      this.page1.pageNumber = pageNumber;
      this.pageList1();
    },

    handleSelectionChange (val) {
      console.log(val)
      if (val.length > 1) {
        this.$refs.singleTb.clearSelection()
        this.$refs.singleTb.toggleRowSelection(val.pop())
      } else {
        this.ids = val.map((e) => ({
          objectId: e.id,
          name: e.name,
          goodsId: this.goodsItemIdData.id,
          type: this.type,
        }));
      }
    },
    onSelectAll () {
      this.$refs.singleTb.clearSelection()
    },
    selectionChange (val) {
      this.multipleSelection = val;
      this.ids = val.map((e) => ({
        objectId: e.id,
        name: e.name,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
      console.log(this.ids)
    },
    pageList () {
      this.api.goodsInfo.seriesPageList({ pageSize: 10, pageNumber: 1, goodsSeriesId: this.$route.query.updatePageGoodsItem }).then((result) => {
        this.page.rows = result.data ? result.data : [];
        this.page.total = result.data.total;
        this.loading = false;
      }).catch((error) => {
        console.log(error);
      });
    },
  },
  mounted () {
    this.getGoodsItemData();
    this.queryData = this.$route.query;
  },
};
</script>
<style lang="less" scoped>
.type-btn {
  transform: translateX(-50%);
  margin-left: 50%;
  margin-top: 15px;
}
.line {
  display: inline-block;
  margin: 0 5px;
  border-left: 1px solid #a39e9e75;
  height: 10px;
}
.draggable-tableaaa {
  margin-top: 20px;
  border-top: 1px solid #d9ebf5;
  border-left: 1px solid #d9ebf5;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }
  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }
    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      img {
        display: none !important;
      }
      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;
        img {
          display: none !important;
        }
      }
    }
    .title {
      width: 60%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .state {
        padding: 0;
        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      white-space: nowrap;
    }
    .answer {
      width: 22%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .delete {
      width: 12%;
      cursor: pointer;
      border-bottom: 1px solid #d9ebf5;
      text-align: center;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.row {
  display: flex;
}
.mb10 {
  margin-bottom: 10px;
}
.jsa {
  justify-content: space-around;
}
.form-row {
  align-items: center;
  display: flex;
  .icons {
    margin-left: 10px;
  }
  .form-item {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goods/bindGoodsByBatch.vue